(function () {
    'use strict';
  
    const DESKTOP_MIN = 990;
    let syncingVariants = false;
  
    function isDesktop() {
      return window.innerWidth >= DESKTOP_MIN;
    }
  
    function getProductSection() {
      return document.querySelector('[data-section-type="product"]');
    }
  
    function getMainAddToCartButton() {
      const stickyBar = document.querySelector('.product__popup.sticky-bar');
      return Array.from(document.querySelectorAll('[data-add-to-cart]')).find(
        (button) => !button.closest('.product__popup') && !button.closest('[data-sticky-mobile-atc="root"]')
      );
    }
  
    function getMainVariantsBlock() {
      const section = getProductSection();
      if (!section) return null;
      return section.querySelector('.product__inner .product__block__variants');
    }
  
    function syncStickyPricesFromMain() {
      const section = getProductSection();
      if (!section) return;
  
      const mainInner = section.querySelector('.product__inner');
      if (!mainInner) return;
  
      const mainPrice = mainInner.querySelector('[data-product-price]');
      const mainCompare = mainInner.querySelector('[data-compare-price-dynamic]');
      const mainPriceOff = mainInner.querySelector('[data-price-off]');
  
      if (!mainPrice) return;
  
      const priceText = mainPrice.textContent.trim();
      const compareText = mainCompare ? mainCompare.textContent.trim() : '';
      const hasCompare = !!(mainPriceOff && !mainPriceOff.classList.contains('hide') && compareText);
      const isOnSale = mainPrice.classList.contains('product__price--sale') || hasCompare;
  
      document.querySelectorAll('[data-sticky-bar-price]').forEach((el) => {
        el.textContent = priceText;
        el.classList.toggle('product__price--sale', isOnSale);
      });
  
      document.querySelectorAll('[data-sticky-mobile-price]').forEach((el) => {
        el.textContent = priceText;
      });
  
      document.querySelectorAll('[data-sticky-bar-compare]').forEach((el) => {
        el.textContent = compareText;
      });
  
      document.querySelectorAll('.product__popup [data-price-off]').forEach((wrap) => {
        wrap.classList.toggle('hide', !hasCompare);
      });
    }
  
    function observeMainPriceChanges() {
      const section = getProductSection();
      if (!section || section.dataset.stickyPriceObserved === 'true') return;
      section.dataset.stickyPriceObserved = 'true';
  
      const mainInner = section.querySelector('.product__inner');
      const priceWrap = mainInner?.querySelector('[data-price-wrapper]') || mainInner?.querySelector('[data-product-price]');
      if (!priceWrap) return;
  
      const sync = () => syncStickyPricesFromMain();
      sync();
  
      const observer = new MutationObserver(sync);
      observer.observe(priceWrap, { childList: true, subtree: true, characterData: true });
    }
  
    function onVariantChange(event) {
      const variant = event.detail?.variant;
      setTimeout(() => {
        syncStickyPricesFromMain();
        const floatedForm = document.querySelector('floated-form');
        const mainVariants = getMainVariantsBlock();
        const floatedVariants = floatedForm?.querySelector('.product__block__variants');
        if (mainVariants && floatedVariants) {
          syncVariantBlocks(mainVariants, floatedVariants);
        }
      }, 50);
      if (variant) updateStickyButtonText(variant);
    }
  
    function updateStickyButtonText(variant) {
      const buttons = document.querySelectorAll(
        '.product__popup [data-sticky-bar-atc-text], [data-sticky-mobile-atc="root"] [data-sticky-bar-atc-text]'
      );
  
      buttons.forEach((el) => {
        if (!variant) {
          el.textContent = window.theme?.strings?.unavailable || 'Unavailable';
          return;
        }
        if (!variant.available) {
          el.textContent = window.theme?.strings?.soldOut || 'Sold out';
          return;
        }
        el.textContent = window.theme?.strings?.addToCart || 'Add to cart';
      });
    }
  
    function getPriceStickyTrigger() {
      const section = getProductSection();
      return (
        section?.querySelector('.product__inner .product__block__price') ||
        section?.querySelector('.product__inner [data-price-wrapper]') ||
        section?.querySelector('.product__inner [data-product-price]')
      );
    }
  
    function getMobileStickyTrigger() {
      return getPriceStickyTrigger();
    }
  
    function getDesktopStickyTrigger() {
      return getPriceStickyTrigger();
    }
  
    function initStickyVisibility(stickyBar, { getTrigger, desktopOnly = false, mobileOnly = false } = {}) {
      if (!stickyBar || stickyBar.dataset.stickyInitialized === 'true') return;
      stickyBar.dataset.stickyInitialized = 'true';
  
      let isTriggerVisible = true;
      let triggerObserver = null;
  
      const isEnabled = () => {
        if (desktopOnly) return isDesktop();
        if (mobileOnly) return !isDesktop();
        return true;
      };
  
      const updateStickyState = () => {
        if (!isEnabled()) {
          stickyBar.classList.remove('active');
          return;
        }
        stickyBar.classList.toggle('active', !isTriggerVisible);
      };
  
      const observeTrigger = () => {
        const trigger = typeof getTrigger === 'function' ? getTrigger() : getTrigger;
        if (!trigger) return;
  
        if (triggerObserver) triggerObserver.disconnect();
  
        triggerObserver = new IntersectionObserver(
          (entries) => {
            isTriggerVisible = entries[0].isIntersecting;
            updateStickyState();
          },
          { threshold: 0, rootMargin: '0px 0px -8px 0px' }
        );
        triggerObserver.observe(trigger);
        updateStickyState();
      };
  
      observeTrigger();
      window.addEventListener('theme:resize', observeTrigger);
    }
  
    /* ------------------------------------------------------------------ */
    /* Desktop sticky visibility                                          */
    /* ------------------------------------------------------------------ */
  
    function initDesktopStickyPopup() {
      const stickyBar = document.querySelector('.product__popup.sticky-bar');
      if (!stickyBar) return;
      initStickyVisibility(stickyBar, {
        getTrigger: getDesktopStickyTrigger,
        desktopOnly: true,
      });
    }
  
    /* ------------------------------------------------------------------ */
    /* Variant sync between main PDP and floated form                     */
    /* ------------------------------------------------------------------ */
  
    function getOptionInputs(root) {
      if (!root) return [];
      return Array.from(
        root.querySelectorAll('input[name^="options["], [data-single-option-selector]')
      );
    }
  
    function getSelectedOptions(root) {
      const options = {};
      const groups = new Set();
  
      getOptionInputs(root).forEach((input) => {
        if (!input.name) return;
        groups.add(input.name);
      });
  
      groups.forEach((name) => {
        const checked = root.querySelector(`input[name="${CSS.escape(name)}"]:checked`);
        const hidden = root.querySelector(
          `input[name="${CSS.escape(name)}"][type="hidden"], input[name="${CSS.escape(name)}"][data-popout-input]`
        );
        if (checked) {
          options[name] = checked.value;
        } else if (hidden) {
          options[name] = hidden.value;
        }
      });
  
      return options;
    }
  
    function updatePopoutLabel(input) {
      const popout = input.closest('[data-popout]');
      if (!popout) return;
      const toggle = popout.querySelector('[data-popout-toggle]');
      if (toggle) {
        const labelSpan = toggle.querySelector('[data-ayar-toggle-text]');
        if (labelSpan) {
          labelSpan.textContent = input.value;
        } else {
          toggle.textContent = input.value;
        }
      }
      popout.querySelectorAll('[data-popout-option]').forEach((opt) => {
        const isCurrent = opt.getAttribute('data-value') === input.value;
        opt.parentElement.classList.toggle('select-popout__item--current', isCurrent);
        opt.toggleAttribute('aria-current', isCurrent);
      });
    }
  
    function applyOptionsToBlock(targetRoot, options) {
      if (!targetRoot) return;
  
      Object.entries(options).forEach(([name, value]) => {
        const radio = targetRoot.querySelector(
          `input[type="radio"][name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`
        );
        if (radio) {
          radio.checked = true;
        } else {
          const hidden = targetRoot.querySelector(
            `input[name="${CSS.escape(name)}"][data-popout-input], input[name="${CSS.escape(name)}"][type="hidden"]`
          );
          if (hidden && hidden.value !== value) {
            hidden.value = value;
            updatePopoutLabel(hidden);
          }
        }
  
        const wrapper = targetRoot.querySelector(`[data-option-position] input[name="${CSS.escape(name)}"]`)?.closest('[data-option-position]') ||
          targetRoot.querySelector(`input[name="${CSS.escape(name)}"]`)?.closest('[data-option-position]');
        const legend = wrapper?.querySelector('[data-option-value]');
        if (legend) legend.textContent = value;
      });
    }
  
    function syncVariantBlocks(fromRoot, toRoot) {
      if (!fromRoot || !toRoot || syncingVariants) return;
      syncingVariants = true;
      applyOptionsToBlock(toRoot, getSelectedOptions(fromRoot));
      syncingVariants = false;
    }
  
    function bindFloatedVariantSync(floatedForm) {
      const mainVariants = getMainVariantsBlock();
      const floatedVariants = floatedForm.querySelector('.product__block__variants');
      if (!mainVariants || !floatedVariants) return;

      syncVariantBlocks(mainVariants, floatedVariants);
  
      floatedVariants.addEventListener('change', (event) => {
        if (syncingVariants) return;
        const input = event.target;
        if (!input.matches('input[name^="options["], [data-single-option-selector]')) return;
  
        syncingVariants = true;
  
        const name = input.name;
        const value = input.type === 'radio' ? input.value : input.value;
  
        const mainRadio = mainVariants.querySelector(
          `input[type="radio"][name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`
        );
        if (mainRadio) {
          mainRadio.checked = true;
          mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const mainHidden = mainVariants.querySelector(
            `input[name="${CSS.escape(name)}"][data-popout-input], input[name="${CSS.escape(name)}"][type="hidden"]`
          );
          if (mainHidden) {
            mainHidden.value = value;
            updatePopoutLabel(mainHidden);
            mainHidden.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
  
        syncingVariants = false;
      });
  
      mainVariants.addEventListener('change', (event) => {
        if (syncingVariants) return;
        if (!event.target.matches('input[name^="options["], [data-single-option-selector]')) return;
        syncVariantBlocks(mainVariants, floatedVariants);
      });
  
      floatedVariants.addEventListener('click', (event) => {
        const option = event.target.closest('[data-popout-option]');
        if (!option) return;

        event.preventDefault();
        const value = option.getAttribute('data-value');
        const popout = option.closest('[data-popout]');
        const hidden = popout?.querySelector('[data-popout-input]');
        if (!hidden) return;

        hidden.value = value;
        updatePopoutLabel(hidden);
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    function bindStickyAddToCartProxy(container) {
      container.querySelectorAll('[data-sticky-bar-atc]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const mainButton = getMainAddToCartButton();
          if (mainButton) mainButton.click();
        });
      });
      bindStickyButtonLoadingSync();
    }
  
    function syncStickyButtonStates() {
      const mainButton = getMainAddToCartButton();
      if (!mainButton) return;
  
      document.querySelectorAll('[data-sticky-bar-atc]').forEach((btn) => {
        btn.classList.toggle('loading', mainButton.classList.contains('loading'));
        btn.classList.toggle('has-success', mainButton.classList.contains('has-success'));
        if (mainButton.hasAttribute('disabled')) {
          btn.setAttribute('disabled', 'disabled');
        } else {
          btn.removeAttribute('disabled');
        }
      });
    }
  
    function bindStickyButtonLoadingSync() {
      const mainButton = getMainAddToCartButton();
      if (!mainButton) return;
  
      const section = getProductSection();
      if (section?.dataset.stickyLoadingSync === 'true') {
        syncStickyButtonStates();
        return;
      }
      if (section) section.dataset.stickyLoadingSync = 'true';
  
      const observer = new MutationObserver(syncStickyButtonStates);
      observer.observe(mainButton, { attributes: true, attributeFilter: ['class', 'disabled'] });
      syncStickyButtonStates();
    }
  
    /* ------------------------------------------------------------------ */
    /* FloatedForm web component                                          */
    /* ------------------------------------------------------------------ */
  
    class FloatedForm extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.tryRenderForm(0);
      }
  
      tryRenderForm(attempt) {
        const section = getProductSection();
        const inner = section?.querySelector('.product__inner');
        const buttonsBlock = inner?.querySelector('.product__block__buttons');
  
        if (!inner || !buttonsBlock) {
          if (attempt < 30) {
            window.setTimeout(() => this.tryRenderForm(attempt + 1), 100);
          }
          return;
        }
  
        this.renderForm();
      }
  
      renderForm() {
        if (this.dataset.loaded === 'true') return;
  
        const sectionId = this.getAttribute('data-section-id');
        const showQuantity = this.getAttribute('data-show-quantity') === 'true';
        const showDynamicCheckout = this.getAttribute('data-show-dynamic-checkout') === 'true';
        const mainFormId = this.getAttribute('data-main-form-id');
  
        const section = getProductSection();
        const inner = section?.querySelector('.product__inner');
        if (!inner) return;
  
        const variantsBlock = inner.querySelector('.product__block__variants');
        const siblingsBlock = inner.querySelector('.product__block__siblings');
        const buttonsBlock = inner.querySelector('.product__block__buttons');
        const quantityBlock = inner.querySelector('.product__block__quantity');
  
        const fragment = document.createDocumentFragment();
        const optionsWrap = document.createElement('div');
        optionsWrap.className = 'product__sticky-options';
  
        if (siblingsBlock) {
          const clone = siblingsBlock.cloneNode(true);
          this.cleanClonedNode(clone, sectionId);
          optionsWrap.appendChild(clone);
        }
  
        if (variantsBlock) {
          const clone = variantsBlock.cloneNode(true);
          this.cleanClonedNode(clone, sectionId);
          optionsWrap.appendChild(clone);
        }
  
        if (showQuantity && quantityBlock) {
          const clone = quantityBlock.cloneNode(true);
          this.cleanClonedNode(clone, sectionId);
          clone.querySelectorAll('[form]').forEach((el) => {
            el.setAttribute('form', mainFormId);
          });
          optionsWrap.appendChild(clone);
        }
  
        if (optionsWrap.childElementCount) {
          fragment.appendChild(optionsWrap);
        }
  
        const actions = document.createElement('div');
        actions.className = 'product__sticky-form-actions product__submit';
  
        const fallbackBtn = this.querySelector('[data-sticky-bar-atc]');
        const submitBtn = buttonsBlock?.querySelector('[data-add-to-cart]') || fallbackBtn;
  
        if (submitBtn) {
          const buttonsWrap = document.createElement('div');
          buttonsWrap.className = 'product__submit__buttons';
  
          const btn = submitBtn.cloneNode(true);
          btn.removeAttribute('id');
          btn.removeAttribute('form');
          btn.removeAttribute('onclick');
          btn.setAttribute('type', 'button');
          btn.setAttribute('data-sticky-bar-atc', '');
          btn.disabled = false;
  
          if (!btn.querySelector('.btn-state-ready')) {
            const text = btn.textContent.trim();
            btn.textContent = '';
            btn.innerHTML =
              '<span class="btn-state-ready"><span data-sticky-bar-atc-text data-add-to-cart-text></span></span>' +
              '<span class="btn-state-loading"><svg height="18" width="18" class="svg-loader"><circle r="7" cx="9" cy="9" /><circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9" /></svg></span>' +
              '<span class="btn-state-complete">&nbsp;</span>';
            btn.querySelector('[data-sticky-bar-atc-text]').textContent = text;
          } else {
            const textEl = btn.querySelector('[data-add-to-cart-text]') || btn.querySelector('[data-sticky-bar-atc-text]');
            if (textEl) textEl.setAttribute('data-sticky-bar-atc-text', '');
          }
  
          buttonsWrap.appendChild(btn);
          actions.appendChild(buttonsWrap);
        }
  
        if (showDynamicCheckout && buttonsBlock) {
          const quickCheckout = buttonsBlock.querySelector('.product__submit__quick');
          if (quickCheckout) {
            const checkoutClone = quickCheckout.cloneNode(true);
            this.cleanClonedNode(checkoutClone, sectionId);
            actions.appendChild(checkoutClone);
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          }
        }
  
        fragment.appendChild(actions);
        this.replaceChildren(fragment);
        this.dataset.loaded = 'true';
  
        this.upgradeClonedCustomElements(this);
        bindFloatedVariantSync(this);
        bindStickyAddToCartProxy(this);
        syncStickyPricesFromMain();
      }
  
      cleanClonedNode(node, sectionId) {
        node.querySelectorAll('.floated-form-hide, floated-form, script, [data-product-json]').forEach((el) => {
          el.remove();
        });
  
        node.querySelectorAll('.select__fieldset[style], .select-popout[style], .selector-wrapper[style]').forEach((el) => {
          el.removeAttribute('style');
        });
  
        node.querySelectorAll('[id]').forEach((el) => {
          el.id = `floated-${sectionId}-${el.id}`;
        });
  
        node.querySelectorAll('[for]').forEach((el) => {
          const forId = el.getAttribute('for');
          if (forId) el.setAttribute('for', `floated-${sectionId}-${forId}`);
        });
  
        node.querySelectorAll('[aria-controls]').forEach((el) => {
          const controls = el.getAttribute('aria-controls');
          if (controls) el.setAttribute('aria-controls', `floated-${sectionId}-${controls}`);
        });
  
        node.querySelectorAll('[aria-labelledby]').forEach((el) => {
          const labelledby = el.getAttribute('aria-labelledby');
          if (labelledby) el.setAttribute('aria-labelledby', `floated-${sectionId}-${labelledby}`);
        });
  
        node.querySelectorAll('[form]').forEach((el) => {
          el.removeAttribute('form');
        });
      }
  
      upgradeClonedCustomElements(root) {
        root.querySelectorAll('popout-select, radio-swatch').forEach((el) => {
          const template = document.createElement('template');
          template.innerHTML = el.outerHTML.trim();
          const replacement = template.content.firstElementChild;
          if (replacement) {
            el.replaceWith(replacement);
          }
        });
      }
    }
  
    /* ------------------------------------------------------------------ */
    /* Mobile sticky add to cart                                          */
    /* ------------------------------------------------------------------ */
  
    class StickyMobileAddToCart extends HTMLElement {
      connectedCallback() {
        this.root = this.querySelector('[data-sticky-mobile-atc="root"]');
        if (!this.root) return;
  
        this.initObserver();
        this.bindProxyClick();
      }
  
      initObserver() {
        initStickyVisibility(this.root, {
          getTrigger: getMobileStickyTrigger,
          mobileOnly: true,
        });
      }
  
      bindProxyClick() {
        this.root.querySelectorAll('[data-sticky-bar-atc]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const mainButton = getMainAddToCartButton();
            if (mainButton) mainButton.click();
          });
        });
        bindStickyButtonLoadingSync();
      }
    }
  
    /* ------------------------------------------------------------------ */
    /* Init                                                               */
    /* ------------------------------------------------------------------ */
  
    function initProductStickyBar() {
      initDesktopStickyPopup();
      observeMainPriceChanges();
      bindStickyButtonLoadingSync();
  
      if (!document.documentElement.dataset.stickyVariantListener) {
        document.documentElement.dataset.stickyVariantListener = 'true';
        document.addEventListener('theme:variant:change', onVariantChange);
      }
  
      syncStickyPricesFromMain();
  
      const initialJson = getProductSection()?.querySelector('[data-product-json]');
      if (initialJson) {
        try {
          const product = JSON.parse(initialJson.textContent);
          const urlVariantId = new URLSearchParams(window.location.search).get('variant');
          let variant = null;
          if (urlVariantId) {
            variant = product.variants.find((v) => v.id === Number(urlVariantId));
          }
          if (!variant) {
            variant = product.variants.find((v) => v.available) || product.variants[0];
          }
          if (variant) updateStickyButtonText(variant);
        } catch (e) {
          /* ignore */
        }
      }
    }
  
    if (!customElements.get('floated-form')) {
      customElements.define('floated-form', FloatedForm);
    }
  
    if (!customElements.get('sticky-mobile-addtocart')) {
      customElements.define('sticky-mobile-addtocart', StickyMobileAddToCart);
    }
  
    document.addEventListener('DOMContentLoaded', initProductStickyBar);
    document.addEventListener('shopify:section:load', initProductStickyBar);
  })();
  